module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Write-65e156e21cf4e1fc444a1cf570bc4753.svg";